import { connect } from 'react-redux';

import {
  areFunnelsFetching,
  isFunnelDeleting,
  isFunnelUpdating,
  isFunnelExecuting,
  getExecuteIdsFromJobIds,
  getFunnelExecuteId,
} from '../../reducers/analyticsApp';
import CompoundView from '../../components/compound/View';
import { cancelRequest } from '../../api/execute';

const mapStateToProps = (state) => {
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = getFunnelExecuteId(state);

  return {
    fetching: areFunnelsFetching(state),
    deleting: isFunnelDeleting(state),
    executing: isFunnelExecuting(state),
    updating: isFunnelUpdating(state),
    cancelButtonDisabled: !executeIds.includes(executeId),
    executeId,
    isFunnelLocation: true,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompoundView);
